import { useTranslation } from 'react-i18next'

import { Account } from '@pages/Trade/types'

import { Button, IconButton } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip'
import { ArrowLeftRightIcon } from '@ui/icons/ArrowLeftRight.icon'
import { CoinPlusIcon } from '@ui/icons/CoinPlus.icon'

import { useWindowResize } from '@utils/domUtils'

import { isTradingAccountStatusApproved } from '@model/TradingAccount'

import { TradingViewTradeButton } from './TradingViewTradeButton'

import styles from './TradingAccountInfoActions.module.scss'

type TradingAccountInfoActionsProps = {
  onClickDeposit?: () => void
  onClickTransfer?: () => void
  addBalance?: () => void
  isDemo?: boolean
  transferRestrictedTooltip?: string
  depositRestrictedTooltip?: string
  account: Account
  isTradingViewAccount: boolean
}
export const TradingAccountInfoActions = ({
  onClickDeposit,
  onClickTransfer,
  isDemo = false,
  transferRestrictedTooltip,
  depositRestrictedTooltip,
  addBalance,
  account,
  isTradingViewAccount,
}: TradingAccountInfoActionsProps) => {
  const isMobile = useWindowResize()
  const { t } = useTranslation()

  const addBalanceRestrictedTooltip = !isTradingAccountStatusApproved(account.status)
    ? t('This action is not available')
    : undefined

  if (isDemo) {
    return (
      <div className={styles.actions}>
        {isMobile ? (
          <>
            <Tooltip content={addBalanceRestrictedTooltip} disabled={!addBalanceRestrictedTooltip}>
              <IconButton.Secondary
                onClick={addBalanceRestrictedTooltip ? undefined : addBalance}
                icon={CoinPlusIcon}
                disabled={!!addBalanceRestrictedTooltip}
              />
            </Tooltip>
            {isTradingViewAccount && <TradingViewTradeButton account={account} />}
          </>
        ) : (
          <>
            <Tooltip content={addBalanceRestrictedTooltip} disabled={!addBalanceRestrictedTooltip}>
              <Button.Secondary
                size='sm'
                onClick={addBalanceRestrictedTooltip ? undefined : addBalance}
                disabled={!!addBalanceRestrictedTooltip}
              >
                {t('Markets.AddBalance')}
              </Button.Secondary>
            </Tooltip>
          </>
        )}
      </div>
    )
  }

  return (
    <div className={styles.actions}>
      {isMobile ? (
        <>
          <Tooltip content={depositRestrictedTooltip} disabled={!depositRestrictedTooltip}>
            <IconButton.Primary
              onClick={depositRestrictedTooltip ? undefined : onClickDeposit}
              icon={CoinPlusIcon}
              disabled={!!depositRestrictedTooltip}
            />
          </Tooltip>

          <Tooltip content={transferRestrictedTooltip} disabled={!transferRestrictedTooltip}>
            <IconButton.Secondary
              onClick={transferRestrictedTooltip ? undefined : onClickTransfer}
              icon={ArrowLeftRightIcon}
              disabled={!!transferRestrictedTooltip}
            />
          </Tooltip>
          {isTradingViewAccount && <TradingViewTradeButton account={account} />}
        </>
      ) : (
        <>
          <Tooltip content={depositRestrictedTooltip} disabled={!depositRestrictedTooltip}>
            <Button.Primary
              size='sm'
              onClick={depositRestrictedTooltip ? undefined : onClickDeposit}
              disabled={!!depositRestrictedTooltip}
            >
              {t('Markets.Deposit')}
            </Button.Primary>
          </Tooltip>

          <Tooltip content={transferRestrictedTooltip} disabled={!transferRestrictedTooltip}>
            <Button.Secondary
              size='sm'
              onClick={transferRestrictedTooltip ? undefined : onClickTransfer}
              disabled={!!transferRestrictedTooltip}
            >
              {t('Markets.Transfer')}
            </Button.Secondary>
          </Tooltip>
        </>
      )}
    </div>
  )
}
